export const normalize: (text: string) => string = (text: string) => (text.toLowerCase()).normalize('NFD').replace(/[\u0300-\u036f]/g, '');
